var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.984 0.815994H15.36C14.688 0.815994 14.16 1.34399 14.16 2.01599C14.16 2.68799 14.688 3.21599 15.36 3.21599H19.056L14.64 7.63199C11.232 5.08799 6.38399 5.32799 3.31199 8.39999C-0.0480077 11.76 -0.0480077 17.28 3.31199 20.64C6.67199 24 12.192 24 15.552 20.64C18.624 17.568 18.912 12.672 16.32 9.31199L20.736 4.89599V8.63999C20.736 9.31199 21.264 9.83999 21.936 9.83999C22.608 9.83999 23.136 9.31199 23.136 8.63999V2.01599C23.184 1.34399 22.656 0.815994 21.984 0.815994ZM13.92 18.96C11.472 21.408 7.48799 21.408 5.03999 18.96C2.59199 16.512 2.59199 12.528 5.03999 10.08C7.48799 7.63199 11.472 7.63199 13.92 10.08C16.368 12.528 16.368 16.512 13.92 18.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/Male.d08d14f367ad0ae1cea45c0a54ce068d.svg";
export { ForwardRef as ReactComponent };